// PB-Lux contact info — single source of truth
export const CONTACT = {
  phone: "+63 917 164 5433",
  phoneRaw: "+639171645433",
  whatsapp: "+63 930 631 2062",
  whatsappRaw: "+639306312062",
  email: "pearlybellones21@gmail.com",
  facebookUrl: "https://www.facebook.com/share/18K5R72Ans/?mibextid=wwXIfr",
  // Messenger link — uses Facebook's m.me which redirects to messenger;
  // fall back to the FB page URL for chat.
  messengerUrl: "https://www.facebook.com/share/18K5R72Ans/?mibextid=wwXIfr",
  address: "In front of Motortrade, San Miguel, Puerto Princesa City, Palawan, Philippines",
};

export const waLink = (message) =>
  `https://wa.me/${CONTACT.whatsappRaw.replace("+", "")}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const waVehicleMessage = (vehicle, opts = {}) => {
  let msg = `Hi PB-Lux! I would like to inquire about the ${vehicle?.name || "a vehicle"}`;
  if (opts.pickupDate && opts.returnDate) msg += ` from ${opts.pickupDate} to ${opts.returnDate}`;
  if (opts.pickupLocation) msg += `, pickup at ${opts.pickupLocation}`;
  if (opts.dropoffLocation) msg += `, drop-off at ${opts.dropoffLocation}`;
  msg += ". Please check availability and the total rate. Thank you!";
  return msg;
};
